export default function TechnicalSection() {
  const services = [
    {
      icon: 'ri-tools-line',
      title: 'Manutenção Especializada',
      description: 'Técnicos certificados para todos os tipos de consoles com diagnóstico preciso'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Peças Originais',
      description: 'Utilizamos apenas componentes originais com garantia de qualidade'
    },
    {
      icon: 'ri-time-line',
      title: 'Atendimento Rápido',
      description: 'Orçamento em até 24h e reparo ágil para você voltar a jogar logo'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Limpeza Preventiva',
      description: 'Manutenção preventiva para aumentar a vida útil do seu console'
    }
  ];

  const differentials = [
    {
      icon: 'ri-store-2-fill',
      title: 'Loja Física Estabelecida',
      description: 'Localizada na Rua Aurora, 200 no coração da Santa Ifigênia'
    },
    {
      icon: 'ri-team-fill',
      title: '223 Mil Seguidores',
      description: 'Compre de quem você conhece e confia há anos no mercado'
    },
    {
      icon: 'ri-shield-star-fill',
      title: 'Segurança Total',
      description: 'Garantia oficial em todos os produtos e serviços prestados'
    },
    {
      icon: 'ri-price-tag-3-fill',
      title: 'Melhor Custo-Benefício',
      description: 'Preços justos e competitivos com parcelamento facilitado'
    }
  ];

  return (
    <section id="assistencia" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-black via-gray-900 to-black relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#0047AB] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Assistência Técnica <span className="text-[#0047AB]">Especializada</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Manutenção profissional de consoles com garantia e peças originais
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-gray-900 to-black border border-[#0047AB]/30 rounded-xl p-6 hover:border-[#0047AB] transition-all duration-300 hover:shadow-xl hover:shadow-[#0047AB]/20 group"
            >
              <div className="w-16 h-16 bg-[#0047AB]/20 rounded-lg flex items-center justify-center mb-4 group-hover:bg-[#0047AB]/30 transition-colors duration-300">
                <i className={`${service.icon} text-3xl text-[#0047AB]`}></i>
              </div>
              <h3 className="text-lg font-bold text-white mb-2">{service.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mb-12">
          <h3 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            Diferenciais <span className="text-[#0047AB]">Estratégicos</span>
          </h3>
          <p className="text-lg text-gray-400">
            Por que escolher a Gamer Station para suas compras e manutenções
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {differentials.map((item, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-[#0047AB]/10 to-transparent border border-[#0047AB]/30 rounded-xl p-6 hover:border-[#0047AB] transition-all duration-300 hover:shadow-xl hover:shadow-[#0047AB]/20 text-center group"
            >
              <div className="w-16 h-16 bg-[#0047AB] rounded-full flex items-center justify-center mb-4 mx-auto group-hover:scale-110 transition-transform duration-300">
                <i className={`${item.icon} text-3xl text-white`}></i>
              </div>
              <h4 className="text-lg font-bold text-white mb-2">{item.title}</h4>
              <p className="text-gray-400 text-sm leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <a 
            href="https://wa.me/5511951063038" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-[#0047AB] text-white px-8 py-4 rounded-lg hover:bg-[#003380] transition-all duration-300 text-lg font-bold cursor-pointer shadow-xl shadow-[#0047AB]/40 hover:shadow-[#0047AB]/60 hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-customer-service-2-line mr-2"></i>
            Solicitar Orçamento de Manutenção
          </a>
        </div>
      </div>
    </section>
  );
}